import React, { createContext, useState, useEffect, ReactNode } from "react";
import { axiosInstance } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../utils/constants";

interface ImageUrls {
  [key: string]: string;
}

export const ImagesContext = createContext<ImageUrls>({});

interface ImagesProviderProps {
  children: ReactNode;
}

export const ImagesProvider: React.FC<ImagesProviderProps> = ({ children }) => {
	const [images, setImages] = useState<ImageUrls>({});


	return (
		<ImagesContext.Provider value={images}>
			{children}
		</ImagesContext.Provider>
	);
};
